// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { ICONS } from '@Constants/iconsApp';
import { Button, Space } from 'antd';
import IconLabel from '@Atoms/Info/IconLabel/IconLabel';
import { classList } from '@Helpers/className';

import './DisplayDate.scss';

export interface DisplayDateProps {
    date: string;
    timestamp: number;
    dateInvalidMessage?: string;
    fromDate?: string;
    defaultStyle?: boolean;
    icon?: boolean;
    label?: string;
    onClick?: (date: number) => void;
    className?: string;
}

const DisplayDate = ({
    date = '',
    label = '',
    timestamp = 0,
    dateInvalidMessage = '',
    fromDate = '',
    defaultStyle = true,
    icon = false,
    onClick,
    className,
}: DisplayDateProps): ReactElement => {
    const classNameProcessed = classList(className, { 'display-date': defaultStyle });

    if (!timestamp) {
        return <span className="no-item-label">{dateInvalidMessage}</span>;
    }

    if (fromDate) {
        return (
            <div className={classList(classNameProcessed, { 'block-width': defaultStyle })}>
                <span className="date-day">{date}</span>
                <IconLabel icon={<ICONS.ClockCircleOutlined />} label={fromDate} />
            </div>
        );
    }

    return onClick ? (
        <div className={classNameProcessed}>
            <Button
                onClick={(): void => onClick?.(timestamp)}
                type="link"
                icon={icon && <ICONS.DateIcon />}
                size="small"
                className="display-date__button"
            >
                {`${label}${date}`}
            </Button>
        </div>
    ) : (
        <Space className={classNameProcessed}>
            {icon && <ICONS.DateIcon />}
            {`${label}${date}`}
        </Space>
    );
};

export default DisplayDate;
